export const PATH_SEGMENTS = {
  rootPath: "/upsert-profile",
  conflictResolver: "/conflict-resolver",
  profiles: "/profiles",
  editProfile: "/edit-profile",
  editNewProfile: "/edit_new_profile",
} as const;

export function getProfileTypeFromPathname(pathname: string): "individual" | "entity" | null {
  if (pathname.includes("/individual/")) return "individual";
  if (pathname.includes("/entity/")) return "entity";
  return null;
}

export function getPageHeader(pathname: string, isJointRoot = false): string {
  if (pathname.includes(PATH_SEGMENTS.conflictResolver)) return "Resolve profile conflicts";
  if (pathname.includes(PATH_SEGMENTS.editProfile)) {
    const profileType = getProfileTypeFromPathname(pathname);
    if (profileType === "individual") return "Edit Individual";
    if (profileType === "entity") return "Edit Entity";
    return "Edit profile";
  }
  // A joint root can only have individual owner children.
  return isJointRoot ? "Create new owner" : "Create new owner or controller";
}
